"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getHexOpacity = function getHexOpacity(hex, p) {
  var percent = Math.max(0, Math.min(100, p)); // bound percent from 0 to 100

  var intValue = Math.round(percent / 100 * 255); // map percent to nearest integer (0 - 255)

  var hexValue = intValue.toString(16); // get hexadecimal representation

  return hex + hexValue.padStart(2, '0').toUpperCase(); // format with leading 0 and upper case characters
};

var _default = getHexOpacity;
exports["default"] = _default;